export default __webpack_public_path__ + "static/media/select-sanjiao.ba364287.svg";